import React from 'react';
import 'antd/lib/layout/style/css';
import 'antd/lib/menu/style/css';
import 'antd/lib/avatar/style/css';
import 'antd/lib/dropdown/style/css';
import 'antd/lib/button/style/css';
import 'antd/lib/icon/style/css';
import 'antd/lib/drawer/style/css';
import './PublicHeader.css';
import changeLanguage from "../../../actions/changeLanguage";
import {push} from "connected-react-router";
import {connect} from "react-redux";

class PublicHeader extends React.Component {
  
  handleLanguage = () =>
  {
    this.props.changeLanguage(this.props.language);
  };
  
  render() {
	return <></>;
  }
}

function mapStateToProps(state) {
    return {
        language: state.auth.language
    }
}

export default connect(mapStateToProps, {push, changeLanguage})(PublicHeader);